import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { isArray, isNullOrUndefined } from 'util';
import { GenericErrorHandlerService } from './generic-error-handler.service';

@Injectable({
    providedIn: 'root'
})
export class FormSupportService {

    constructor(
        private genericErrorHandlerService: GenericErrorHandlerService,
    ) {
    }

    public formSubmitHelper(form, onSubmitMethod?: Function, ...methodArgs: Array<any>): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (form.valid) {
                if (!isNullOrUndefined(onSubmitMethod)) {
                    onSubmitMethod(...methodArgs[0])
                        .then(response => {
                            resolve(response);
                        })
                        .catch(error => {
                            if (error && error.error && error.error.validationMessage) {
                                this.genericErrorHandlerService.setFormErrors(form, error.error.validationMessage);
                                reject(error);
                            }
                        });
                } else {
                    resolve(true);
                }
            } else {
                this.genericErrorHandlerService.showErrors(form);
                reject(false);
            }
        });
    }

    public convertDataBeforeSend(data: Object): any {
        const copyObject = JSON.parse(JSON.stringify(data));
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const field = data[key];
                if (typeof field === 'object') {
                    if (field instanceof Date) {
                        copyObject[key] = this.convertDateToString(field);
                    } else {
                        copyObject[key] = this.convertDataBeforeSend(field);
                    }
                }
            }
        }
        return copyObject;
    }

    public convertDateAndTimeBeforeSend(data: Object): any {
        const copyObject = JSON.parse(JSON.stringify(data));
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const field = data[key];
                if (typeof field === 'object') {
                    if (field instanceof Date) {
                        const regex = /time/gi;
                        if (regex.test(key)) {
                            copyObject[key] = this.convertTimeToString(field);
                        } else {
                            copyObject[key] = this.convertDateToString(field);
                        }
                    } else {
                        copyObject[key] = this.convertDateAndTimeBeforeSend(field);
                    }
                }
            }
        }
        return copyObject;
    }

    public convertDataToDate(data: Object): any {
        const dateReg = /^\d{2}[./-]\d{2}[./-]\d{4}$/;
        const copyObject = JSON.parse(JSON.stringify(data));
        for (const key in data) {
            if (data.hasOwnProperty(key) && !isNullOrUndefined(data[key])) {
                const field = data[key];
                if (typeof field === 'object') {
                    copyObject[key] = this.convertDataToDate(field);
                } else if (isArray(field) && field.length > 0) {
                    field.map(val => this.convertDataToDate(val))
                } else if (typeof field === 'string' && field.match(dateReg)) {
                    copyObject[key] = this.convertStringToDate(field);
                }
            }
        }
        return copyObject;
    }

    public convertDateToString(date: Date): string {
        return date.getFullYear() + '-' + (Number(date.getMonth()) + 1) + '-' + date.getDate();
    }

    public convertTimeToString(date: Date): string {
        return date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    }

    public convertStringToDate(date: string): Date {
        let _date = null;
        const dateReg = /^\d{4}[./-]\d{1,2}[./-]\d{1,2}/;
        const timeRegex = /^\d{2}[:]\d{2}[:]?\d{0,2}/;
        if (!isNullOrUndefined(date) && date.split && date.match(dateReg)) {
            const dateWithoutTime = date.split(' ')[0];
            const dateArray: Array<number> = /-/g.test(dateWithoutTime) ? dateWithoutTime.split('-').map(Number)
                : dateWithoutTime.split('.').map(Number);
            if (dateArray && dateArray.length) {
                _date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
            }
        } else if (!isNullOrUndefined(date) && date.split && date.match(timeRegex)) {
            const timeArray: Array<number> = date.split(':').map(Number);
            if (timeArray && timeArray.length) {
                _date = new Date(Date.now());
                _date.setHours(timeArray[0], timeArray[1], timeArray[2] ? timeArray[2] : 0);
            }
        }
        return _date;
    }
}
